import * as React from "react";
const Person = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("mask", { id: "prefix__a", width: 94, height: 94, x: 1, y: 1, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M95 1H1v94h94z" })),
    React.createElement("g", { mask: "url(#prefix__a)" },
        React.createElement("mask", { id: "prefix__b", width: 94, height: 94, x: 1, y: 1, maskUnits: "userSpaceOnUse", style: {
                maskType: "luminance",
            } },
            React.createElement("path", { fill: "#fff", d: "M95 1H1v94h94z" })),
        React.createElement("g", { mask: "url(#prefix__b)" },
            React.createElement("path", { fill: "#CFCFCF", d: "M16.7 71.5V95H48V40.2c-17.3 0-31.3 14-31.3 31.3" }),
            React.createElement("path", { fill: "#3F3F3F", d: "M48 40.2V95h31.3V71.5c0-17.3-14-31.3-31.3-31.3" }),
            React.createElement("path", { fill: "#ED0000", d: "M48 40.2c10.77 0 19.5-8.731 19.5-19.5S58.77 1.2 48 1.2 28.5 9.93 28.5 20.7 37.23 40.2 48 40.2" })))));
export default Person;
//# sourceMappingURL=Person.js.map